export const experiences = [
  {
    id: 1,
    title: "Web Developer Intern",
    company: "WebStack Academy",
    duration: "(Jul 2025 - Present)"
  },
  {
    id: 2,
    title: 'Full Stack Developer Intern',
    company: "Meraki Designing Services",
    duration: "(June 2025 - July 2025)"
  },
  // {
  //   id: 3,
  //   title: "Self Employed",
  //   company: "Code and build something in everyday.",
  //   duration: "(Jan 2018 - Present)"
  //   }
]